<div class="info-bottom center" [ngClass]="{'standalone': standalone, 'belong-grid': gridLegends}">
	<div [class]="orientation" class="graph-legend" [ngClass]="{'line-scroll': scroll}">
		<ng-container *ngFor="let item of legends">
			<div class="legend-item gap" >
				<div class="circle big" [ngClass]="item.type"></div>
				<div class="name">{{item.name | translate}}
					<ng-container *ngIf="showValueLegend">
						<ng-container [ngSwitch]="dataType">:&nbsp;
							<span *ngSwitchCase="'pages'"[innerHTML]="item.value | pageCount" ></span>
							<span *ngSwitchDefault>{{item.value}}</span>
						</ng-container>
					</ng-container>
				</div>
			</div>
		</ng-container>
	</div>
</div>